import { Switch, Typography, FormControlLabel, Stack, Tooltip } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

export interface SwitchConfigProps {
  checked: boolean;
  onChange: (ConfigTypeKey1: string, AssignedValue1: any, ConfigTypeKey2?: string, AssignedValue2?: any) => void;
  name: string;
  label: string;
  description?: string;
  restProps?: object;
  showLabel?: boolean;
}

export default function SwitchConfig({ name, label, description, checked, onChange, restProps, showLabel }: SwitchConfigProps) {
  return !!showLabel ? (
    <Stack direction="row" alignItems="center" sx={{ py: 1 }}>
      {!!description && <Tooltip title={description} placement="right">
        <HelpIcon sx={{ fontSize: 16, color: "#C4C4C4", cursor: "pointer", mr: "9px" }} />
      </Tooltip>}
      <FormControlLabel
        control={<Switch name={name} checked={checked} onChange={(event) => onChange(event.target.name, event.target.checked)} {...restProps} />}
        label={
          <Typography
            sx={{
              fontFamily: "Work Sans",
              fontWeight: 400,
              fontSize: "12px",
              lineHeight: "22px",
            }}
          >
            {label}
          </Typography>
        }
        labelPlacement="end"
      />
    </Stack>
  ) : (
    <Stack direction="row" alignItems="center" sx={{ py: 1 }}>
      {!!description && <Tooltip title={description} placement="right">
        <HelpIcon sx={{ fontSize: 16, color: "#C4C4C4", cursor: "pointer", mr: "9px" }} />
      </Tooltip>}

      <Switch name={name} checked={checked} onChange={(event) => onChange(event.target.name, event.target.checked)} {...restProps} />
    </Stack>
  );
}
